export { DrawerOffsets, MousePosition, ModalContainerState, IModalContainer, ModalManagerType } from 'choerodon-ui/shared/modal-manager';
export { ModalManager as default } from 'choerodon-ui/shared';
